import { render, staticRenderFns } from "./NoteCreateComponent.vue?vue&type=template&id=b88331f6&scoped=true&"
import script from "./NoteCreateComponent.vue?vue&type=script&lang=js&"
export * from "./NoteCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoteCreateComponent.vue?vue&type=style&index=0&id=b88331f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88331f6",
  null
  
)

export default component.exports